import { GridColDef as IMuiGridColDef } from '@mui/x-data-grid/models/colDef/gridColDef';
import { Box, Button, Link as MuiLink, Typography } from '@mui/material';
import { ReportGrid } from '@tap/mui-ui/src/XGridTable/ReportGrid';
import { IComponentCss, getGeneratedDynamicLink, numberHelper } from '@tap/mui-ui';
import { IssueTimeSpentReportResult } from '@tap/data-providers';
import { Link } from 'react-router';
import { RoutesData } from '../../../routes/routes';

/*
*   Таблица Затраченное время
*/

// Цвета для ячеек со значениями
const css: IComponentCss = {
    tableWrap: {
        position: 'relative',
        height: 'calc(100vh - 125px)',
        width: 1,
        '& .table-wrap.is-value': {
            backgroundColor: '#FBDBB5',
            borderBottomColor: '#FBDBB5',
        },
        '& .table-wrap.is-red-value': {
            backgroundColor: '#FFBDBD',
            borderBottomColor: '#FFBDBD',
        },
    },
    optionsButton: {
        zIndex: 1,
        position: 'absolute',
        right: '4px',
        top: '5px',
        height: '28px',
    },
};

// Столбцы и их параметры
const getColumns = (): IMuiGridColDef<any, any, any>[] => {
    return ([
        {
            // Задача
            field: 'documentKey',
            headerName: 'Заявка',
            headerAlign: 'left',
            align: 'left',
            flex: 1,
            sortable: false,
            renderCell: (cellParams) => (
                <>
                    <MuiLink
                        component={Link}
                        to={getGeneratedDynamicLink(
                            RoutesData.detailsPageRoutes.path,
                            [
                                { key: 'documentKey', value: cellParams.row?.documentKey },
                            ],
                        )}
                    >
                        {cellParams.row.documentKey}
                    </MuiLink>
                    <Typography sx={{ marginLeft: '5px' }}>{cellParams.row.title}</Typography>
                </>
            ),
        },
        {
            // Название
            field: 'title',
            headerName: 'Название',
            type: 'string',
            sortable: false,
            hide: true,
        },
        {
            // Затраты
            field: 'totalSpentMin',
            headerName: 'Затрачено',
            type: 'number',
            sortable: false,
            valueGetter: (_val, row) => numberHelper.formatNumberWithDotDelimiter(row.totalSpentMin / 60, 2),
            renderCell: cellParams => `${numberHelper.formatNumberWithDotDelimiter(cellParams.row.totalSpentMin / 60, 2).toString().replace('.', ',')} ч`,
        },
    ])
}

const getRowsList = (reportData: IssueTimeSpentReportResult[]) => {
    return reportData.map((item, idx) => ({ ...item, id: idx }));
}

type IssueTimeSpentTableProps = {
    reportData: IssueTimeSpentReportResult[],
    onOptionsButtonClick: () => void,
}

export default function IssueTimeSpentTable({ reportData, onOptionsButtonClick }: IssueTimeSpentTableProps) {
    const rowList = getRowsList(reportData);

    return (
        <>
            {/* Таблица */}
            <Box sx={css.tableWrap}>
                <Button
                    size='small'
                    sx={css.optionsButton}
                    onClick={onOptionsButtonClick}
                >
                    Параметры отчёта
                </Button>

                <ReportGrid
                    columns={getColumns()}
                    rows={rowList}
                    tableProps={{
                        rowHeight: 22,
                    }}
                />
            </Box>
        </>
    );
}
